import actions from '@/features/upload/store/upload.store.actions'
import getters from '@/features/upload/store/upload.store.getters'
import mutations from '@/features/upload/store/upload.store.mutation'

export interface IUploadStore {
  url: string,
  fields: any,
  parsingOptions: IParsingOptions
}

export interface IUploadData {
  uploadData: any,
  file: any
}

export interface IParsingOptions {
  xlsDateFormat: string
  delimiterFormat: string
}

export interface IUploadAdditional {
  name: string | boolean | number,
  value: string | boolean | number | File | Blob
}

export const state: IUploadStore = {
  url: '',
  fields: [],
  parsingOptions: {
    xlsDateFormat: 'dd-mm-yyyy hh:mm:ss',
    delimiterFormat: ','
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
